import React, { Component } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Popover from "@mui/material/Popover";
import MoreIcon from "@mui/icons-material/MoreHoriz";
import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import IconButton from "@mui/material/IconButton";
import { GoDotFill } from "react-icons/go";
import { GrAttachment } from "react-icons/gr";
import { IoSyncSharp } from "react-icons/io5";
import { BsSearch } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { DateRangeBox } from "devextreme-react/date-range-box";
import { ScrollView } from "devextreme-react/scroll-view";
import { Allotment } from "allotment";
import { connect } from "react-redux";
import classNames from "classnames";
import dayjs from "dayjs";
import { messagesRoot } from "../../services/constants";
import { postAPIMessage, postAPIMessages } from "../../redux/actions";
import { toLocalTime } from "../../components/helperFunctions/helperFunctions";
import ViewMessageContent from "../ViewMessageContent";
import ApiReadSecureMessage from "../../services/ApiReadSecureMessage";
import ApiAssignMessage from "../../services/ApiAssignMessage";
import SearchInputs from "./SearchInputs";
import "allotment/dist/style.css";
import "./viewContent.styles.css";

const now = new Date();
const maxDate = new Date().setDate(now.getDate() + 2);

class ViewContent extends Component {
  anchorEl = {};
  constructor(props) {
    super(props);
    this.state = {
      open: {},
      page: 1,
      allotmentSize: this.getAllotmentSize(),
      isViewAll: Boolean(localStorage.getItem("viewAllSecuredMessages")),
      isFilterOn: false,
      isSearchOn: false,
      emailsList: this.props.getAPIMessages,
      permission: this.props.permissions.includes(
        "SecuredMessageCenterEmployee"
      ),
      selectedEmail: null,
      isThereforeOpen: false,

      thereforeData: {
        Firm: "",
        Office: "",
        Account: "",
        Short_Name: "",
        Sales_Code: "",
        CNA_1: "",
        Tax_ID: "",
        CFTC_Office: "",
        CFTC_Account: "",
        Date_Opened: "",
        Date_Closed: "",
        Doc_Type: "",
        Doc_ID: "",
        Date_Scanned: "",
        Original_account_number: "",
        Original_Firm: "",
        Original_Office: "",
        Original_S_Code: ""
      }
    };
    this.apiClass = props.apiClass;
    this.apiReadSecureMessage = new ApiReadSecureMessage(this.apiClass);
    this.apiAssignMessage = new ApiAssignMessage(this.apiClass);
    this.onFilterApplied = this.onFilterApplied.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.getAPIMessages !== this.props.getAPIMessages) {
      this.setState({ emailsList: this.props.getAPIMessages });
    }
    if (prevProps.path !== this.props.path) {
      this.setState({ selectedEmail: null });
    }
    if (prevProps.getAPIMailbox !== this.props.getAPIMailbox) {
      this.setState({ selectedEmail: null });
    }
  }

  getAllotmentSize() {
    let sizes = localStorage.getItem("allotmentSize");
    if (sizes) {
      return sizes.split(",").map((el) => parseFloat(el));
    }
    return [370, 800];
  }
  messageClicked(message) {
    this.markAsRead(message);
    if (window.innerWidth <= 768) {
      this.props.history.push(
        "/" +
          this.props.getAPIMailbox +
          "/" +
          this.props.path +
          "/" +
          message.messageID
      );
    } else {
      this.setState({ selectedEmail: message });
    }
  }

  markAsUnread = async (message) => {
    let params = {
      messageId: message.messageID,
      mailbox: this.props.getAPIMailbox
    };
    return await this.apiClass
      .CallApi("putQuery", messagesRoot + "UnreadMessage", params)
      .then(() => this.props.updateMessages());
  };

  markAsRead = async (message) => {
    if (message.read === true) return;
    return await this.apiReadSecureMessage
      .callApi(message.messageID, this.props.getAPIMailbox)
      .then(() => this.props.updateMessages());
  };

  deleteMessage = async (message) => {
    return await this.apiClass
      .DeleteSecureMessages(message.messageID, this.props.getAPIMailbox)
      .then(() => this.props.updateMessages());
  };

  assignMessage = async (message, unassign = "") => {
    if (unassign === "unassign") {
      return await this.apiAssignMessage
        .callApi(message.messageID, "none")
        .then(() => this.props.updateMessages());
    }
    return await this.apiAssignMessage
      .callApi(message.messageID, this.props.ownerEmail)
      .then(() => this.props.updateMessages());
  };

  filterAssignedEmails = () => {
    this.setState({ isFilterOn: !this.state.isFilterOn });
    this.setState({
      emailsList: this.state.emailsList?.filter(
        (email) => email.assignTo === this.props.ownerEmail
      )
    });
  };

  removeFilterAssignedEmails = () => {
    return this.setState({
      isFilterOn: !this.state.isFilterOn,
      emailsList: this.props.getAPIMessages
    });
  };

  handleModalClose() {
    this.setState({ isThereforeOpen: false });
  }

  updateThereforeData(data) {
    this.setState({ thereforeData: data });
  }

  setAttachments(files) {
    if (files.length !== 0) {
      files.forEach((item) => {
        let blobLink = item.link.substring(0, item.link.indexOf("?"));
        this.props.attachments.push(blobLink);
      });
    }
  }

  showMailTime(time) {
    if (dayjs(time).subtract(5, "hours").isSame(dayjs(), "day")) {
      return dayjs(toLocalTime(time)).format("h:mm A");
    } else {
      return dayjs(time).format("MM/DD/YYYY");
    }
  }

  isEmailAssigned(assignTo) {
    //some prev emails have "undefined or NULL" as assignTo. even if you pass empty string, db adds string NULL.
    if (assignTo === "undefined" || assignTo === "NULL" || !assignTo) {
      return false;
    } else {
      return true;
    }
  }

  handleChangePage = async (e, newLastSMCPage) => {
    this.setState({ page: newLastSMCPage });
  };

  viewAllMessages = () => {
    const isViewAll = Boolean(localStorage.getItem("viewAllSecuredMessages"));
    this.setState({
      page: 1,
      isViewAll: isViewAll ? false : true
    });
    localStorage.setItem("viewAllSecuredMessages", isViewAll ? "" : "true");
  };

  onDateRangeChanged = (e) => {
    this.props.onDateChanged(e.value);
  };

  onCalendarClosed = () => {
    this.props.updateMessages();
  };

  onDrageEndHandler = (sizes) => {
    localStorage.setItem("allotmentSize", sizes);
    this.setState({ allotmentSize: sizes });
  };

  onFilterApplied = (newData) => {
    this.setState({ emailsList: [...newData] });
  };

  render() {
    const { page } = this.state;
    const itemsPerPage = this.state.isViewAll
      ? this.state.emailsList.length
      : 9;
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const messagesCount = this.state.emailsList?.filter(
      (x) => x.status === this.props.action
    );
    return (
      <div>
        <div>
          <div className="allotment-container">
            <Allotment
              defaultSizes={this.state.allotmentSize}
              onDragEnd={this.onDrageEndHandler}
            >
              <Allotment.Pane
                size={this.state.allotmentSize[0]}
                minSize={370}
                className={classNames({
                  "allotment-right-side": true,
                  "large-padding": this.state.isSearchOn
                })}
              >
                <div>
                  <div className="email-filters">
                    <div className="d-flex align-items-start justify-center gap-2">
                      <div className="filter-icon">
                        <Tooltip title="assigned to me">
                          {this.state.isFilterOn ? (
                            <button
                              className="btn btn-light btn-md py-0 px-2"
                              onClick={this.removeFilterAssignedEmails}
                            >
                              <MdClose size={16} color="red" />
                            </button>
                          ) : (
                            <button
                              className="btn btn-light btn-md py-0 px-2"
                              onClick={this.filterAssignedEmails}
                            >
                              <BsFillPersonLinesFill />
                            </button>
                          )}
                        </Tooltip>
                      </div>
                      <div className="filter-icon">
                        <Tooltip title="search">
                          <button
                            className="btn btn-light btn-md py-0 px-2"
                            onClick={() =>
                              this.setState({
                                isSearchOn: !this.state.isSearchOn
                              })
                            }
                          >
                            {this.state.isSearchOn ? (
                              <MdClose size={16} color="red" />
                            ) : (
                              <BsSearch size={16} />
                            )}
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                    <div className="date-inputs">
                      <DateRangeBox
                        endDateLabel="To"
                        startDateLabel="From"
                        labelMode="hidden"
                        invalidEndDateMessage="End value must be a date"
                        invalidStartDateMessage="Start value must be a date"
                        max={maxDate}
                        startDate={this.props.fromDate}
                        endDate={this.props.toDate}
                        onValueChanged={(e) => this.onDateRangeChanged(e)}
                        onClosed={this.onCalendarClosed}
                      />
                    </div>

                    <Tooltip title="Refresh">
                      <IconButton
                        style={{
                          padding: "0",
                          margin: "0",
                          color: "white"
                        }}
                        onClick={() => this.props.updateMessages()}
                      >
                        <IoSyncSharp
                          size={25}
                          className={classNames({
                            "refresh-icon__rotate": this.props.isMessagesLoading
                          })}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {this.state.isSearchOn ? (
                    <div className="search-fields">
                      <SearchInputs
                        onFilterApplied={this.onFilterApplied}
                        emailList={this.props.getAPIMessages}
                        isFilterOn={this.state.isFilterOn}
                        ownerEmail={this.props.ownerEmail}
                      />
                    </div>
                  ) : null}
                </div>
                <ScrollView
                  reachBottomText={"No more messages"}
                  height={"100%"}
                  showScrollbar="always"
                >
                  <List style={{ padding: "0px 0px 2px 0px" }}>
                    {this.state.emailsList
                      .filter((x) => x.status === this.props.action)
                      .slice(startIndex, endIndex)
                      .map((x) => {
                        const toAddresses = x.toAddresses[0]?.split(",") || "";
                        return (
                          <ListItem
                            key={x.sentTime}
                            onClick={() => this.messageClicked(x)}
                            className={classNames({
                              "email-list-item": true,
                              "email-list-item__selected":
                                x.messageID ===
                                this.state.selectedEmail?.messageID,
                              "email-list-item__unread": !x.read
                            })}
                            sx={{
                              cursor: "pointer",
                              display: "block",
                              width: "100%"
                            }}
                            message={x}
                          >
                            <div className="email-list-container">
                              <div>
                                {this.props.action === "Sent" ? (
                                  <div>
                                    <strong>To: </strong>
                                    <strong> {toAddresses[0]}</strong>
                                    {toAddresses.length > 1
                                      ? ` & 
                                      ${toAddresses.length - 1} 
                                           others`
                                      : null}
                                  </div>
                                ) : (
                                  <div className="email-list__from-header">
                                    {!x.read ? (
                                      <GoDotFill
                                        size={15}
                                        className="from-header__dot-icon"
                                      />
                                    ) : null}

                                    <span
                                      className={classNames({
                                        "from-header__unread": !x.read
                                      })}
                                    >
                                      <strong>{x.from}</strong>
                                    </span>
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "end"
                                  }}
                                >
                                  <span
                                    className={classNames({
                                      "form-header__unread-subject": !x.read
                                    })}
                                  >
                                    {x.subject.slice(0, 100)}
                                  </span>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      minWidth: "fit-content",
                                      paddingTop: "5px",
                                      fontWeight: x.read ? "bold" : "bolder"
                                    }}
                                  >
                                    {this.showMailTime(x.sentTime)}
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "5px"
                                  }}
                                >
                                  <div
                                    style={{
                                      display: this.state.permission
                                        ? "block"
                                        : "none"
                                    }}
                                  >
                                    {this.isEmailAssigned(x.assignTo) ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          fontSize: "14px"
                                        }}
                                      >
                                        assigned to:
                                        <p className="assigned-to-text">
                                          {x.assignTo}
                                        </p>
                                      </div>
                                    ) : (
                                      <p className="unnasigned-to-text">
                                        unnasigned
                                      </p>
                                    )}
                                  </div>
                                  <div>
                                    {x.attachments.length ? (
                                      <GrAttachment />
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "0",
                                  margin: "auto"
                                }}
                              >
                                <IconButton
                                  style={{ padding: "0px" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.anchorEl[x.messageID] =
                                      e.currentTarget;
                                    var newOpen = JSON.parse(
                                      JSON.stringify(this.state.open)
                                    );
                                    newOpen[x.messageID] = true;
                                    this.setState({ open: newOpen });
                                  }}
                                >
                                  <MoreIcon
                                    aria-describedby={x.messageID}
                                    fontSize="large"
                                  />
                                </IconButton>
                                <Popover
                                  id={x.messageID}
                                  open={
                                    this.state.open[x.messageID]
                                      ? this.state.open[x.messageID]
                                      : false
                                  }
                                  onClose={(e) => {
                                    e.stopPropagation();
                                    this.anchorEl[x.messageID] = null;
                                    var newOpen = JSON.parse(
                                      JSON.stringify(this.state.open)
                                    );
                                    newOpen[x.messageID] = false;
                                    this.setState({ open: newOpen });
                                  }}
                                  anchorEl={this.anchorEl[x.messageID]}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center"
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "center"
                                  }}
                                >
                                  <div>
                                    {x.read === false ? (
                                      <button
                                        className="dropdown-menu-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.markAsRead(x);
                                          var newOpen = JSON.parse(
                                            JSON.stringify(this.state.open)
                                          );
                                          newOpen[x.messageID] = false;
                                          this.setState({ open: newOpen });
                                        }}
                                      >
                                        Mark as Read
                                      </button>
                                    ) : (
                                      <button
                                        className="dropdown-menu-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.markAsUnread(x);
                                          var newOpen = JSON.parse(
                                            JSON.stringify(this.state.open)
                                          );
                                          newOpen[x.messageID] = false;
                                          this.setState({ open: newOpen });
                                        }}
                                      >
                                        Mark as Unread
                                      </button>
                                    )}

                                    <button
                                      className="dropdown-menu-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.deleteMessage(x);
                                        var newOpen = JSON.parse(
                                          JSON.stringify(this.state.open)
                                        );
                                        newOpen[x.messageID] = false;
                                        this.setState({ open: newOpen });
                                      }}
                                    >
                                      Delete Message
                                    </button>

                                    <button
                                      className="dropdown-menu-btn"
                                      style={{
                                        display: this.state.permission
                                          ? "block"
                                          : "none"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        let unassign =
                                          x.assignTo === this.props.ownerEmail
                                            ? "unassign"
                                            : "";
                                        this.assignMessage(x, unassign);
                                        var newOpen = JSON.parse(
                                          JSON.stringify(this.state.open)
                                        );
                                        newOpen[x.messageID] = false;
                                        this.setState({ open: newOpen });
                                      }}
                                    >
                                      {x.assignTo === this.props.ownerEmail
                                        ? "Unassign from me"
                                        : "Assign to me"}
                                    </button>
                                    <button
                                      className="dropdown-menu-btn"
                                      style={{
                                        display: this.state.permission
                                          ? "block"
                                          : "none"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        var newOpen = JSON.parse(
                                          JSON.stringify(this.state.open)
                                        );
                                        this.setState({ open: newOpen });
                                        this.setAttachments(x.attachments);
                                        this.props.postAPIMessage(x);
                                        this.props.openThereforePopup();
                                      }}
                                    >
                                      Save to Therefore
                                    </button>
                                  </div>
                                </Popover>
                              </div>
                            </div>
                          </ListItem>
                        );
                      })}
                    {this.state.emailsList.length === 0 &&
                      !this.props.isMessagesLoading && (
                        <p className="text-center mt-2">
                          You do not have any messages for selected dates
                        </p>
                      )}
                  </List>
                </ScrollView>
                <div className="pagination-box">
                  <span onClick={this.viewAllMessages}>
                    {this.state.isViewAll ? "View less" : "View all"}
                  </span>
                  <Pagination
                    count={Math.ceil(messagesCount.length / itemsPerPage) || 1}
                    page={page}
                    onChange={this.handleChangePage}
                    shape="rounded"
                  />
                </div>
              </Allotment.Pane>
              <Allotment.Pane
                className="allotment-left-side"
                size={this.state.allotmentSize[1]}
              >
                <div className="allotment-left-side">
                  {this.state.selectedEmail ? (
                    <ViewMessageContent
                      apiClass={this.apiClass}
                      mailbox={this.props.getAPIMailbox}
                      path={this.props.path}
                      history={this.props.history}
                      action={this.props.action}
                      messageId={this.state.selectedEmail.messageID}
                    />
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        fontSize: "16px"
                      }}
                    >
                      Please select an email
                    </p>
                  )}
                </div>
              </Allotment.Pane>
            </Allotment>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    getAPIMessages: state.API.Messages,
    getAPIMailbox: state.API.Mailbox
  };
}

const mapDispatchToProps = {
  postAPIMessage,
  postAPIMessages
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewContent);
